import { CartItem } from '@api/cart/cart.models';
import { ProductPublicModels } from '@features/products/product';
import { ProductViewPlace } from '@shared/product/models';

export const getExcludedProductsUseCase = (
    place: ProductViewPlace,
    shopCartItems: CartItem[] = [],
    baseProducts?: ProductPublicModels.PublicProduct[],

): ProductPublicModels.PublicProduct[] => {
    if (place && !!baseProducts && shopCartItems.length) {
        return [
            ...baseProducts,
            ...shopCartItems,
        ] as ProductPublicModels.PublicProduct[];
    }
    return [
        ...baseProducts && [...baseProducts] || []];
};
